import { LayoutContainer, TrustpilotWidget } from '@selina-finance/ui';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className='border-t border-mono-30 bg-almond-500'>
            <LayoutContainer className='flex flex-col gap-6 py-32px text-center text-sm text-midnight-600 lg:text-left'>
                <div className='flex flex-col items-center gap-2 lg:flex-row lg:items-center lg:justify-between'>
                    <div className='flex items-center gap-2'>
                        <div className='transform scale-80 lg:-ml-5 lg:scale-100'>
                            <TrustpilotWidget textColor='#3A3C55' />
                        </div>
                    </div>
                </div>
                <div className='h-px w-full bg-almond-100' />
                <div className='space-y-3'>
                    <p>{t('footer.companyReg')}</p>
                    <p>{t('footer.fcaDetails')}</p>
                </div>
            </LayoutContainer>
        </footer>
    );
};

export default Footer;
